class SvgFrameAnimatorSetting {
    public animationName: string = '';
    public framesCount: number = 0;
    public fps: number = 0;
    public repeat: boolean;
    public frames: any[] = [];

    constructor(animationName: string, framesCount: number, fps: number, frames: any[], repeat?: boolean) {
        this.animationName = animationName;
        this.framesCount = framesCount;
        this.fps = fps;
        this.frames = frames;
        if(repeat != undefined)
            this.repeat = repeat;
        else
            this.repeat = false;
    }
}

export default SvgFrameAnimatorSetting;